import { StaticInterface } from '../../../helpers/static-interface';
import TpxFilterMenuUtils from '../../molecules/filter/filter-menu.utils';

export interface ITpxListUtils {
}

export interface IStaticTpxListUtils {
  new(...args: any[]): ITpxListUtils;
  init(): void;
}

/**
 * List utilities
 * @class
 */
export default class TpxListUtils implements StaticInterface<IStaticTpxListUtils, typeof TpxListUtils> {
  /**
   * Sets up the filter menus within this list
   */
  static init() {
    [...document.getElementsByClassName('o-list')].forEach(list => {
      TpxFilterMenuUtils.init(list as HTMLElement);
    });
  }
}